/**
 * h5 用户如果未登录 不发查询券请求
 */
import React, { Component, Fragment } from 'react'
import { LangEum, currencySymbolMap } from '@/constant'
import classnames from 'classnames'
import { Toast } from 'antd-mobile'
import { getNewUserCoupons, receiveCoupon } from './apis'
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from './trackConfig'
import styles from './index.module.less'
import appInstall from '@/utils/appUtils/appInstall'
import { isDuApp } from '@/utils/appUtils/getDevice'
import { BaseComponentItemPropsType } from '@/typings/types'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)

const successMsgMap: any = {
  zh: '领取成功',
  'zh-TW': '領取成功',
  [LangEum['zh-MO']]: '領取成功',
  [LangEum['zh-TW2']]: '領取成功',
  en: 'Claimed successfully',
  ja: '受け取り済み',
  'zh-SG': '领取成功',
  'zh-MY': '领取成功',
}

const errorMsgMap: any = {
  'zh-TW': '该优惠券已领完',
  [LangEum['zh-MO']]: '該優惠券已領完',
  [LangEum['zh-TW2']]: '該優惠券已領完',
  en: 'We’re out of this coupon',
  ja: 'このクーポンは受取上限に達した',
  'zh-SG': '该优惠券已领完',
  'zh-MY': '该优惠券已领完',
}

const expiredTextMap: any = {
  zh: '距过期',
  'zh-TW': '距過期',
  [LangEum['zh-MO']]: '距過期',
  [LangEum['zh-TW2']]: '距過期',
  en: 'Expires in',
  ja: '期限切れまで',
  'zh-SG': '距过期',
  'zh-MY': '距过期',
}

const dayTextMap: any = {
  zh: '天',
  'zh-TW': '天',
  [LangEum['zh-MO']]: '天',
  [LangEum['zh-TW2']]: '天',
  en: 'Days',
  ja: '日',
  'zh-SG': '天',
  'zh-MY': '天',
}

const limitTextMap: any = {
  zh: '无门槛',
  'zh-TW': '無門檻',
  [LangEum['zh-MO']]: '無門檻',
  [LangEum['zh-TW2']]: '無門檻',
  en: 'With Any Order',
  ja: '任意可用',
  'zh-SG': '无门槛',
  'zh-MY': '无门槛',
}

const freeShipTextMap: any = {
  zh: '包邮券',
  'zh-TW': '包郵券',
  [LangEum['zh-MO']]: '包郵券',
  [LangEum['zh-TW2']]: '包郵券',
  en: 'Free Shipping',
  ja: '送料無料',
  'zh-SG': '包邮券',
  'zh-MY': '包邮券',
}

const getLimit = (lang: string, region: string, limitAmount: number): string => {
  const text = {
    zh: `滿${limitAmount / 100}可用`,
    'zh-TW': `滿${limitAmount / 100}可用`,
    [LangEum['zh-MO']]: `滿${limitAmount / 100}可用`,
    [LangEum['zh-TW2']]: `滿${limitAmount / 100}可用`,
    en: `Order≥ ${currencySymbolMap[region]}${limitAmount / 100}`,
    ja: `${limitAmount / 100}以上で使える`,
    'zh-SG': `满${limitAmount / 100}可用`,
    'zh-MY': `满${limitAmount / 100}可用`,
  }
  return text[lang]
}

const zhTW = {
  // 券标题
  title: {
    fontSize: '0.20rem',
  },
  // 券条件
  condition: {
    fontSize: '0.09rem',
  },
  //
  moneyAmount: {
    fontSize: '0.28rem',
  },
  moneySign: {
    fontSize: '0.20rem',
  },
  // 领文案
  led: {
    fontSize: '0.28rem',
  },
}

/**
 * 字体大小
 * 金额
 */
const stylesMap: any = {
  zh: zhTW,
  [LangEum['zh-TW']]: zhTW,
  [LangEum['zh-MO']]: zhTW,
  [LangEum['zh-TW2']]: zhTW,
  [LangEum['zh-SG']]: zhTW,
  [LangEum['zh-MY']]: zhTW,
  en: {
    // 券标题
    title: {
      fontSize: '0.14rem',
      lineHeight: '0.12rem',
      width: '0.85rem',
    },
    // 券条件
    condition: {
      fontSize: '0.08rem',
      lineHeight: '0.10rem',
    },
    //
    moneyAmount: {
      fontSize: '0.14rem',
    },
    moneySign: {
      fontSize: '0.14rem',
    },
    // 领文案
    led: {
      fontSize: '0.14rem',
    },
    couponTop: {
      marginTop: '0.02rem',
    },
  },
}

interface CouponType {
  templateId: number
  title?: string
  subTitle: string // 副标题
  deductionAmount: number // 抵扣金额
  couponType: 1 | 2 // 券类型 1：满减  2：包邮
  [key: string]: any
}

interface BackgroundType {
  expired: string
  notExpired: string
}

interface ItemProps {
  bgImgMap: {
    one: BackgroundType
    two: BackgroundType
    received: BackgroundType
  }
  activityTitle: string
  couponInfo: string
  moneyCode: string
  condition: string
  gotBg: string
  notGotBg: string
  outerBackColor: string
  coupons: CouponType[]
  received: {
    word: string
    wordColor: string
    wordBgColor: string
  }
  unaccalimed: {
    word: string
    wordColor: string
    bgColor: string
    bgImg: string
  }
  activityType?: 1 | 2
}

interface IProps extends BaseComponentItemPropsType<ItemProps, Partial<IState>> {}

const countMap = {
  1: 'one',
  2: 'two',
  3: 'three',
}

const statusTheMap: any = {
  1: 'notGotBg', // 未领取
  2: 'gotBg', // 已领完
  3: 'notExpired', // 已领取未过期
  4: 'expired', // 已领取已过期
}

function CouponsWrapper(props: {
  coupons: CouponType[]
  couponInfo: string
  moneyCode: string
  activityTitle: string
  condition: string
  stylesConfig: any
  lang: string
  couponStatus: 1 | 2 | 3 | 4
  region: string
}) {
  const {
    lang,
    coupons,
    activityTitle,
    couponInfo,
    moneyCode,
    condition,
    stylesConfig,
    region,
    couponStatus,
  } = props
  function getFontColorStyle(obj: any) {
    return obj
  }
  return (
    <div
      className={classnames(
        styles['coupons-wrapper'],
        couponStatus === 4 ? styles['expired'] : styles['available']
      )}
    >
      {(couponStatus < 3 ? [{ title: 'unReceive' }] : coupons).map((ele) => {
        let content = (
          <Fragment>
            <span
              style={{
                ...getFontColorStyle(stylesConfig.moneySign || {}),
                fontSize: coupons.length > 1 ? '0.17rem' : '0.2rem',
              }}
              className={styles['money-sign']}
            >
              {currencySymbolMap[region]}
            </span>
            <span
              style={{
                ...getFontColorStyle(stylesConfig.moneyAmount || {}),
                fontSize: coupons.length > 1 ? '0.24rem' : '0.28rem',
              }}
              className={styles['money-amount']}
            >
              {ele.deductionAmount / 100}
            </span>
          </Fragment>
        )
        if (ele.couponType === 2) {
          content = (
            <div
              style={getFontColorStyle(stylesConfig.title || {})}
              className={styles['coupon-title']}
            >
              {freeShipTextMap[lang]}
            </div>
          )
        }
        return (
          <div
            key={ele.templateId || ele.title}
            className={styles['coupon-item-wrapper']}
            style={{
              flexDirection: couponStatus < 3 ? 'row' : 'column',
              justifyContent: couponStatus < 3 ? 'space-around' : 'center',
            }}
          >
            <div
              style={{
                ...getFontColorStyle(stylesConfig.couponTop || {}),
                flex: couponStatus < 3 ? 1 : '0 1 auto',
              }}
              className={styles['coupon-top']}
            >
              {couponStatus < 3 ? (
                <div className={styles['coupon-info']}>
                  {moneyCode && <span style={{ fontSize: '0.24rem' }}>{moneyCode}</span>}
                  <span>{couponInfo}</span>
                </div>
              ) : (
                content
              )}
            </div>
            <div
              className={
                couponStatus < 3 ? styles['coupon-bottom-available'] : styles['coupon-bottom']
              }
            >
              <span>
                {couponStatus < 3 && (
                  <div className={styles['coupon-bottom-title']}>{activityTitle}</div>
                )}
                {couponStatus < 3
                  ? condition
                  : ele.useLimit === 1
                  ? limitTextMap[lang]
                  : getLimit(lang, region, ele.limitAmount)}
              </span>
            </div>
          </div>
        )
      })}
    </div>
  )
}

function Led(props: {
  couponStatus: number
  receiveCoupon: any
  received: any
  unaccalimed: any
  stylesConfig: any
  lang: string
  restTime: string
}) {
  const { couponStatus, receiveCoupon, received, unaccalimed, stylesConfig, lang, restTime } = props

  function getStyle(obj: any) {
    const nextObj = { ...obj }
    if (couponStatus === 1) {
      nextObj.color = unaccalimed.wordColor || '#4C70B1'
      if (unaccalimed.bgImg) {
        return {
          ...nextObj,
          backgroundImage: `url('${unaccalimed.bgImg}')`,
          backgroundSize: '0.5rem 0.5rem',
          backgroundPosition: 'center center',
        }
      }
      if (unaccalimed.bgColor) {
        return {
          ...nextObj,
          backgroundColor: unaccalimed.bgColor,
        }
      }
    }
    return {
      ...nextObj,
    }
  }
  // 可领取状态
  return (
    <div
      onClick={receiveCoupon}
      className={classnames({
        [styles['right']]: true,
        [styles['receive-word-available']]: couponStatus === 1,
      })}
      style={getStyle(stylesConfig.led || {})}
    >
      {couponStatus === 3 ? (
        <div className={styles['receive-word-received']} style={{ color: received.wordColor }}>
          {restTime && <div>{expiredTextMap[lang]}</div>}
          {restTime && <div className={styles['rest-time']}>{restTime}</div>}
          <div className={styles['receive-btn']}>{received.word}</div>
        </div>
      ) : null}
    </div>
  )
}

interface IState {
  couponStatus: 1 | 2 | 3 | 4
  coupons: CouponType[]
  region: string
  restTime: string
}
@withReactTrack({ createTrackConfig })
class PoizonCouponActivity extends Component<IProps, IState> {
  static config = {
    name: 'poizon-coupon-activity',
  }

  timer = null

  constructor(props: IProps) {
    super(props)
    this.state = {
      couponStatus: 1,
      coupons: [],
      region: 'HK',
      restTime: '',
    }
  }

  componentDidMount() {
    // just Test
    if (!this.props?.prefetchData?.isTrusted) {
      this.queryNewUserCoupons()
    }
  }

  queryNewUserCoupons = () => {
    // H5 未登录 返回
    if (!isDuApp()) {
      return
    }
    if (this.props?.prefetchData?.isTrusted) {
      return
    }
    const { lang, local, id } = this.props?.editConfig
    const { activityType = 1 } = this.props?.propsConfig
    console.log(this.props?.propsConfig)
    const self = this
    getNewUserCoupons(
      {
        language: lang,
        countryCode: local,
        marketingType: activityType,
        uniqueMark: id,
      },
      { language: lang, countryCode: local }
    ).then((res) => {
      self.setState({
        couponStatus: res.data.state,
        coupons: res.data.couponTemplateList,
        region: res.data.region,
      })
      if (res.data.state === 3) {
        this.handleTimeout(res.data.expireTime)
        this.timer = setInterval(() => {
          this.handleTimeout(res.data.expireTime)
        }, 1000)
      }
    })
  }

  receiveCoupon = () => {
    const { lang, local, id } = this.props?.editConfig
    const self = this
    // H5 未登录 返回
    if (!isDuApp()) {
      appInstall()
      return
    }
    const { activityType = 1 } = this.props?.propsConfig
    if (this.state.couponStatus !== 1) {
      return
    }
    receiveCoupon(
      {
        language: lang,
        countryCode: local,
        marketingType: activityType,
        uniqueMark: id,
      },
      { language: lang, countryCode: local }
    )
      .then((res) => {
        if (!res.data.receiveFlag) {
          Toast.info(errorMsgMap[lang])
        } else {
          Toast.info(successMsgMap[lang])
        }
        self.queryNewUserCoupons()
      })
      .catch((error) => {
        self.queryNewUserCoupons()
        console.log(error, 'error...')
      })
  }

  handleTimeout = (expireTime) => {
    if (expireTime === 0) {
      this.setState({
        restTime: '',
      })
      return
    }
    const restTimeStamp = dayjs(expireTime * 1000).diff(dayjs())
    if (restTimeStamp > 0) {
      const days = Math.floor(restTimeStamp / 1000 / 3600 / 24)
        .toString()
        .padStart(2, '0')
      const hours = dayjs.duration(restTimeStamp).hours().toString().padStart(2, '0')
      const minutes = dayjs.duration(restTimeStamp).minutes().toString().padStart(2, '0')
      const seconds = dayjs.duration(restTimeStamp).seconds().toString().padStart(2, '0')
      const { lang } = this.props?.editConfig
      if (Number(days) > 0) {
        let dayText = ''
        if (Number(days) < 2 && lang === 'en') {
          dayText = 'Day'
        } else {
          dayText = dayTextMap[lang]
        }
        this.setState({
          restTime: `${days}${dayText}${hours}:${minutes}:${seconds}`,
        })
      } else {
        this.setState({
          restTime: `${hours}:${minutes}:${seconds}`,
        })
      }
    } else {
      clearInterval(this.timer)
      this.timer = null
      this.setState({
        restTime: '',
        couponStatus: 4,
      })
    }
  }

  render() {
    const { propsConfig } = this.props
    const { couponStatus, coupons, region, restTime } = this.state
    if (!propsConfig) {
      return <div>填完必要参数</div>
    }
    if (!couponStatus) {
      // loading
      return <div>&nbsp;</div>
    }
    const {
      bgImgMap,
      activityTitle,
      couponInfo,
      condition,
      outerBackColor,
      received,
      unaccalimed,
      moneyCode,
    } = propsConfig

    if (!bgImgMap || !coupons) {
      return <div>填完必要参数</div>
    }
    const { lang } = this.props?.editConfig
    const stylesConfig = stylesMap[lang || 'zh-TW'] || zhTW
    return (
      <div
        data-track-click={'poizon_venue_component_content_click'}
        data-track-exposure={'poizon_venue_component_content_exposure'}
        className={styles['poizon-coupon-wrapper']}
        style={{
          background: outerBackColor || '#000',
        }}
      >
        {isDuApp() && !coupons.length ? null : (
          <div
            className={styles['poizon-coupon-content']}
            style={{
              width: coupons.length < 3 ? '3.21rem' : '3.48rem',
            }}
          >
            <img
              src={
                couponStatus < 3
                  ? propsConfig[statusTheMap[couponStatus]]
                  : (bgImgMap as any)[countMap[coupons.length]][statusTheMap[couponStatus]]
              }
              className={styles['bg-img']}
              alt=""
            />
            <div
              className={styles['left']}
              style={{
                marginRight:
                  couponStatus < 3 ? '0' : coupons.length === 3 ? '0.085rem' : '0.365rem',
              }}
            >
              <CouponsWrapper
                couponStatus={couponStatus}
                lang={lang}
                stylesConfig={stylesConfig}
                coupons={coupons}
                couponInfo={couponInfo}
                moneyCode={moneyCode}
                activityTitle={activityTitle}
                condition={condition}
                region={region}
              />
            </div>
            <Led
              receiveCoupon={this.receiveCoupon}
              couponStatus={couponStatus}
              stylesConfig={stylesConfig}
              received={received}
              unaccalimed={unaccalimed}
              restTime={restTime}
              lang={lang}
            />
          </div>
        )}
      </div>
    )
  }
  componentWillUnmount() {
    clearInterval(this.timer)
    this.timer = null
  }
}

PoizonCouponActivity.config = {
  name: 'poizon-coupon-activity',
}

export default PoizonCouponActivity
